jQuery.fn.table2CSV = function(options) {
    var options = jQuery.extend({
            separator: ',',
            header: [],
            delivery: 'popup', // popup, value,
            filename: "export.csv",
            linebreak: "unix",
            title: '',
            auditdata: '',
        },
        options);

    var csvData = [];
    var el = this;

    $(el).each(function(index, item) {
        let tableoptions = {additionalColumns: [], tableSeparator: true};
        let header = $(item).find('> thead');
        if (header.exists() && typeof($(header).data("export-options")) !== "undefined") {
            let exportOptions = $(header).data("export-options");
            for(let key in exportOptions) {
                if(exportOptions.hasOwnProperty(key)) {
                    tableoptions[key] = exportOptions[key];
                }
            }
        }

        if (index > 0 && tableoptions.tableSeparator) {
            row2CSV([" "], []);
        }
        let removeArray = new Array();
        $(header).find('> tr:not(.hideExport) > th').each(function(index, item) {
            if (this.style.display != 'none') {
                if ($(item).hasClass("hideExport")) {
                    removeArray.push(index);
                }
            }
        });

        //header
        var numCols = options.header.length;
        var tmpRow = []; // construct header avalible array

        if (numCols > 0) {
            for (var i = 0; i < numCols; i++) {
                tmpRow[tmpRow.length] = formatData(options.header[i]);
            }
        } else {
            var rowspan = [];
            $(header).find('> tr').each(function() {
                if (this.style.display != 'none') {
                    tmpRow = [];
                    $(this).filter(':visible').find('> th:not(.hideTitle)').each(function(index, item) {
                        if (jQuery.inArray(index, removeArray) === -1) {
                            if (this.style.display != 'none' || $(this).hasClass('exportOnly')) {
                                var repeat = 0;
                                var prerepeat = 0;
                                if (typeof ($(this).attr('colspan')) !== 'undefined') {
                                    repeat = parseInt($(item).attr('colspan'));
                                }
                                if (tmpRow.length in rowspan) {
                                    prerepeat = rowspan[tmpRow.length];
                                    rowspan[tmpRow.length] = 0;
                                }
                                if (typeof ($(this).attr('rowspan')) !== 'undefined') {
                                    rowspan[tmpRow.length] = parseInt($(item).attr('rowspan'));
                                }
                                for (var i = 0; i < prerepeat; i++) {
                                    tmpRow[tmpRow.length] = "";
                                }
                                if ($(this).attr('data-separator') && $(this).attr('data-column-1') && $(this).attr('data-column-2')) {
                                    // Split a header column into two.
                                    tmpRow[tmpRow.length] = formatData($(this).attr('data-column-1'));
                                    tmpRow[tmpRow.length] = formatData($(this).attr('data-column-2'));
                                } else {
                                    // Default behaviour
                                    tmpRow[tmpRow.length] = formatData($(item).text().replace(/\s\s+/g, ' '));
                                }
                                for (var i = 1; i < repeat; i++) { // start at 1 to exclude the data line
                                    tmpRow[tmpRow.length] = "";
                                }
                            }
                        }
                    });
                    row2CSV(tmpRow, tableoptions.additionalColumns);
                }
            });
        }

        //row2CSV(tmpRow);
        // actual data
        $(item).find('> tbody > tr:not(.hideExport), > tfoot > tr:not(.hideExport)').each(function() {
            if (this.style.display != 'none' || $(this).attr('class').indexOf("jPaginate-row-") != -1) {
                tmpRow = [];
                $(this).find('> td').each(function(index, item) {
                    let $item = $(item);
                    if (this.style.display != 'none' || $item.hasClass('exportOnly')) {
                        if ($item.find("table").exists()) {
                            var text = "";
                            $item.find("tbody tr td:not(.hideExport)").each(function() {
                                if (text !== "") {
                                    text += ",";
                                }
                                var inputElement = $(this).find("input:not(:checkbox)");
                                if (inputElement.exists()) {
                                    text += inputElement.val();
                                } else {
                                    text += $(this).text();
                                }

                            });
                            tmpRow[tmpRow.length] = formatData(text);
                        } else if (jQuery.inArray(index, removeArray) === -1) {
                            let repeat = 1;
                            if (typeof ($item.attr('colspan')) != 'undefined') {
                                repeat = parseInt($item.attr('colspan'));
                            }
                            var value = "";
                            var inputElement = $item.find("input:not(:checkbox)");
                            if (inputElement.exists()) {
                                value = formatData(inputElement.val());
                            } else {
                                // removing defined hideExport
                                if ($item.find("span").hasClass('hideExport')) {
                                    // regex will remove everything from: <span class="hideExport to: </span>
                                    var regexp = new RegExp(/(<span class=[\"\']hideExport[\s\S]*?<\/span>)/g);
                                    var itemHtml = $item.html();
                                    itemHtml = itemHtml.replace(regexp, "");
                                    value = formatData(itemHtml);
                                } else if ($item.find('div').hasClass('truncatedText-js')) {
                                    value = formatData($item.find('div').attr('title'));
                                } else {
                                    value = formatData($item.text());
                                }
                            }
                            for (var i = 0; i < repeat; i++) {
                                // Split a header column into two.
                                if ($item.attr('data-separator') && $item.attr('data-column-1') && $item.attr('data-column-2')) {
                                    let dataSeparator = $item.attr('data-separator');
                                    // Split regex search pattern
                                    const searchPattern = new RegExp(dataSeparator.trim()+'(.+)',"");
                                    // Remove quotes around entire string (but not in the middle)
                                    let valueWithoutQuotes = value.replace(/^"(.*)"$/, '$1');
                                    // Split string on the separator (first occurrence only), returns 1st part
                                    let value1 = valueWithoutQuotes.split(searchPattern)[0];
                                    // trim to remove any spaces on either side.
                                    value1 = (value1) ? value1.trim() : undefined;
                                    // Split string on the separator (first occurrence only), returns 2nd part
                                    let value2 = valueWithoutQuotes.split(searchPattern)[1];
                                    // trim to remove any spaces on either side.
                                    value2 = (value2) ? value2.trim() : undefined;

                                    let splitValuePart1 = (value1) ? value1 : '""';
                                    let splitValuePart2 = (value2) ? value2 : '""';
                                    tmpRow[tmpRow.length] = (value1 && value2) ? splitValuePart1 : splitValuePart1;
                                    tmpRow[tmpRow.length] = (value2) ? '"' + splitValuePart2 + '"': splitValuePart2;
                                } else {
                                    // Default behaviour
                                    tmpRow[tmpRow.length] = value;
                                }
                                value = "";
                            }
                        }
                    }
                });
            }
            row2CSV(tmpRow, tableoptions.additionalColumns);
        });
    });
    var lineBreak = "\n";
    if(options.linebreak === "windows"){
        lineBreak = "\r\n";
    }
    var mydata = csvData.join(lineBreak);
    if (options.title !== '') {
        mydata = '\"' + options.title + '\"' + lineBreak + mydata;	// Escape comma characters
    }
    if (options.delivery === 'popup') {
        return popup(mydata);
    } else {
        return mydata;
    }

    function row2CSV(tmpRow, additionalColumns) {
        var tmp = tmpRow.join(''); // to remove any blank rows
        if (tmpRow.length && tmp !== '') {
            const additionalColumnsLength=additionalColumns.length;
            if (additionalColumnsLength) {
                let additionalColumnsFixed=[];
                for (var i = 0; i < additionalColumnsLength; i++){
                    additionalColumnsFixed.push(formatData(additionalColumns[i]));
                }
                tmpRow = $.merge(additionalColumnsFixed, tmpRow);
            }
            csvData[csvData.length] = tmpRow.join(options.separator);
        }
    }

    function formatData(input) {
        // replace " with Ã¢â‚¬Å“
        var regexp = new RegExp(/["]/g);
        var output = input.replace(regexp, '""');
        //HTML
        var regexp = new RegExp(/\<[^\<]+\>/g);
        var output = jQuery.trim(output.replace(regexp, ""));
        if (output === "")
            return '';
        return '"' + output + '"';
    }

    function popup(data) {
        $("body").append('<form id="exportform" action="/common/exportCSV.php" method="post" target="_blank">' +
            '<input type="hidden" id="exportdata" name="exportdata" />' +
            '<input type="hidden" id="filename" name="filename" />' +
            '<input type="hidden" id="auditData" name="auditData" />' +
            '</form>');
        $("#exportdata").val(encodeURIComponent(data));
        $("#filename").val(options.filename);
        $("#auditData").val(options.auditdata);
        $("#exportform").submit().remove();
        return true;
    }
};
